<!-- Mirrors summary-table: banner when header selects full page; hyperlink only if another page exists (`isInLastPage` there = hasNextPage). -->
<div
  class="select-all-message ibc-body-text-large"
  *ngIf="config.features.selectAllAcrossPages">
  <div *ngIf="showSelectAllBanner">
    {{ allItemsSelectedMessage }}
    <span
      *ngIf="showSelectAllHyperlink"
      class="text-hyperlink"
      (click)="onSelectAllClick()"
      (keydown)="$event.stopPropagation()"
      [attr.aria-hidden]="true">
      {{ selectAllItemsMessage }}
    </span>
  </div>
</div>

<div
  class="ibc-summary-table"
  appTableFocusCheckboxShortcut
  appfocusonindividualTabCheckbox
  appHyperLinkShortcut>
  <mat-table
    [dataSource]="matDataSource"
    matSort
    [matSortActive]="config.defaultPagination?.sortField?.toString() || ''"
    [matSortDirection]="config.defaultPagination?.sortDirection || ''"
    matSortDisableClear
    cdkDropList
    cdkDropListOrientation="horizontal"
    [cdkDropListDisabled]="!config.features.columnReorder"
    (cdkDropListDropped)="onColumnDrop($event)">
    
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-divider></mat-divider>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.clicked-row]="row === clickedRow"
      (click)="onRowClick(row)"></mat-row>

    <ng-container matColumnDef="select" *ngIf="config.features.selection">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          *ngIf="!isSingleSelectionMode"
          [checked]="globalHeaderCheckboxState"
          [indeterminate]="indeterminate"
          (change)="onHeaderCheckboxChange($event.checked)"
          [disabled]="matDataSource.data.length === 0">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-radio-button
          *ngIf="isSingleSelectionMode"
          [name]="selectionRadioGroupName"
          (click)="$event.stopPropagation()"
          (change)="onSingleRowSelect(row)"
          [checked]="isRowSelected(row)"
          [disabled]="isRowSelectionDisabled(row)"
          (keydown)="$event.stopPropagation()">
        </mat-radio-button>
        <mat-checkbox
          *ngIf="!isSingleSelectionMode"
          (click)="$event.stopPropagation()"
          (change)="$event.checked ? onRowSelect(row) : onRowDeselect(row)"
          [checked]="isRowSelected(row)"
          [disabled]="isRowSelectionDisabled(row)"
          (keydown)="$event.stopPropagation()">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container
      *ngFor="let column of visibleColumns"
      [matColumnDef]="column.key.toString()">
      
      <mat-header-cell
        *matHeaderCellDef
        cdkDrag
        [cdkDragDisabled]="!config.features.columnReorder"
        [cdkDragData]="column.key.toString()">
        <span class="column-header" [class.cursor]="config.features.columnReorder">
          <span class="ibc-body-text-large">{{ column.label }}</span>
          <span
            mat-sort-header
            *ngIf="isSortShortcutColumn(column)">
            <app-svg-icon
              class="sort-icon"
              [iconName]="'sort'"
              [isStaticSvg]="true"
              [isFrom]="'Page'"
              [condition]="tableSortDirection"
              appSortIconFocus
              [columnIndex]="sortShortcutNumberForColumn(column)">
            </app-svg-icon>
          </span>
        </span>
      </mat-header-cell>

      <mat-cell *matCellDef="let row">
        <ng-container *ngIf="column.isRowActions; else actionOrDefaultCell">
          <div class="gateway-actions-column">
            <button
              *ngFor="let action of getRowActions(row, column)"
              type="button"
              class="ibc-secondary-default-button popup-row-button cursor"
              [class.disabled-button]="isRowActionDisabled(row, column, action)"
              [disabled]="isRowActionDisabled(row, column, action)"
              (click)="onRowActionClick(row, action)">
              {{ action }}
            </button>
          </div>
        </ng-container>
        <ng-template #actionOrDefaultCell>
        <ng-container *ngIf="column.isActionButton; else defaultCell">
          <button class="action-cell-button" (click)="onActionButtonClick(row, column)">
            {{ column.actionButtonLabel }}
          </button>
        </ng-container>
        <ng-template #defaultCell>
          <div class="table-element-display-container">
            <span
              [class.text-hyperlink]="isCellHyperlink(row, column)"
              [class.tooltip-column]="!isCellHyperlink(row, column)"
              [ngClass]="getCellClass(row, column)"
              (click)="onCellClick(row, column)"
              (keydown)="$event.stopPropagation()"
              [matTooltip]="getCellValue(row, column)"
              [matTooltipPosition]="column.infoTooltipPosition || 'above'"
              [matTooltipDisabled]="isCellTooltipDisabled(row, column)">
              {{ getCellValue(row, column) }}
            </span>
            <app-svg-icon
              *ngIf="getInfoIconTooltip(row, column) as infoTooltip"
              [iconName]="'infoCircle'"
              [isStaticSvg]="true"
              [isFrom]="'page'"
              class="info-icon hawb-summary cursor"
              [ngClass]="column.infoIconCssClass"
              [matTooltip]="infoTooltip"
              [matTooltipClass]="column.infoIconTooltipClass || 'custom-tooltip-consignee'"
              [matTooltipPosition]="column.infoTooltipPosition || 'right'">
            </app-svg-icon>
            <app-svg-icon
              *ngIf="shouldShowDashboardShortcutIcon(column)"
              class="dashboard-shortcut-icon cursor"
              [iconName]="'dashboardNavigateShortCut'"
              (click)="onDashboardShortcutIconClick(row, column)"
              (keydown)="$event.stopPropagation()"
              [isStaticSvg]="true">
            </app-svg-icon>
          </div>
        </ng-template>
        </ng-template>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action" *ngIf="config.features.columnCustomization ?? true">
      <mat-header-cell *matHeaderCellDef>
        <div
          tabindex="-1"
          appIconClickShortcut
          (click)="onCustomizeColumnsClick(menuOverlay)"
          (keydown)="$event.stopPropagation()"
          matTooltip="Customize Columns">
          <mat-icon class="cursor view-more-icon">more_vert</mat-icon>
          <div #menuOverlay></div>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element"></mat-cell>
    </ng-container>
  </mat-table>

  <ng-container *ngIf="matDataSource.data.length === 0 && !config.features.hideEmptyMessage">
    <div class="ibc-grid-message-text initial-search-text">
      {{ emptyMessage }}
    </div>
  </ng-container>

  <!-- PaginatedDataService: unbound pageIndex/pageSize (Bag/summary-table pattern); client path keeps bindings below. -->
  <mat-paginator
    *ngIf="serverPagedGrid && paginatorShown"
    class="ibc-table-pagination"
    [length]="totalCount"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    appPaginatorNavigation
    appPaginatorKeyCombination
    showFirstLastButtons>
  </mat-paginator>

  <mat-paginator
    *ngIf="!serverPagedGrid && paginatorShown"
    class="ibc-table-pagination"
    [length]="totalCount"
    [pageIndex]="currentPageIndex"
    [pageSize]="currentPageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    appPaginatorNavigation
    appPaginatorKeyCombination
    showFirstLastButtons>
  </mat-paginator>
</div>
